module.exports = __webpack_public_path__ + "img/more.3d523b96.svg";